import { render, staticRenderFns } from "./TargetForAdmin.vue?vue&type=template&id=2fda45c0"
import script from "./TargetForAdmin.vue?vue&type=script&lang=js"
export * from "./TargetForAdmin.vue?vue&type=script&lang=js"
import style0 from "./TargetForAdmin.vue?vue&type=style&index=0&id=2fda45c0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports